import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TableauToken } from '../models/tableau-token';
import { TableauJwtToken } from '../models/tableauJwt-token';
import { TableauView } from '../models/tableau-views';

@Injectable({
  providedIn: 'root',
})
export class TableauService {
  private readonly GET_TOKEN_URL = `${environment.apiUrl}/tableau/token`;
  private readonly GET_JWTTOKEN_URL = `${environment.apiUrl}/tableau/jwttoken`;
  private readonly GET_REPORT_VIEWS_URL = `${environment.apiUrl}/tableau/reports`;
  private readonly GET_OPPORTUNITIES_VIEWS_URL = `${environment.apiUrl}/tableau/opportunities`;
  private readonly GET_HOMEPAGE_VIEWS_URL = `${environment.apiUrl}/tableau/homepagereports`;
  private readonly GET_LAB_VIEWS_URL = `${environment.apiUrl}/tableau/labviews`;
  private readonly GET_LAB_REPORTS_VIEWS_URL = `${environment.apiUrl}/tableau/labreports`;

  constructor(private httpClient: HttpClient) {}

  public getToken() {
    return this.httpClient.get<TableauToken>(this.GET_TOKEN_URL);
  }

  public getJwtToken() {
    return this.httpClient.get<TableauJwtToken>(this.GET_JWTTOKEN_URL);
  }

  public getReportViewsURI() {
    return this.httpClient.get<TableauView[]>(this.GET_REPORT_VIEWS_URL);
  }

  public getOpportunitiesViewsURI() {
    return this.httpClient.get<TableauView[]>(this.GET_OPPORTUNITIES_VIEWS_URL);
  }

  public getHomepageViewsURI() {
    return this.httpClient.get<TableauView>(this.GET_HOMEPAGE_VIEWS_URL);
  }

  public getLabViews(destino: number) {
    return this.httpClient.get<TableauView>(this.GET_LAB_VIEWS_URL, {
      params: { destino: destino.toString() }
    });
  }

  public getLabViewsArray(destino: number) {
    return this.httpClient.get<TableauView[]>(this.GET_LAB_VIEWS_URL, {
      params: { destino: destino.toString() }
    });
  }

  public getLabReportsViews(destino: number) {
    return this.httpClient.get<TableauView[]>(this.GET_LAB_REPORTS_VIEWS_URL, {
      params: { destino: destino.toString() }
    });
  }
}
